const updateSettings = async (json, store) => {
    const { http, survey, surveyToken } = store
    const { id } = survey

    try {
        const response = await http.put(`/api/survey/${id}/settings`, JSON.stringify(json), surveyToken)
        console.log(response)
        if (response.msg === 'Success') {
            store.addNotification(null, 'Survey updated', 'success')
        } else {
            store.addNotification(null, response.detail, 'error')
        }
    } catch (e) {
        console.log(e)
        store.addNotification(null, e, 'error')
    }
}

export default {
    updateSettings,
}
